<mat-toolbar class="mat-elevation-z8">
  {{ 'PARKING_PRICING.FORM.BULK_UPDATE_PARKING_PRICING' | transloco }}
</mat-toolbar>

@if (isLoading) {
  <div class="spinner">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<mat-dialog-content class="mt-3">

  <form [formGroup]="bulkUpdateParkingPricingForm">

    <mat-form-field class="mb-2" appearance="outline">
      <mat-label>{{ 'PARKING_PRICING.FORM.PRICE_DIFFERENCE' | transloco }}</mat-label>
      <input matInput type="number" formControlName="priceDifference"
        placeholder="{{ 'PARKING_PRICING.FORM.ENTER_PRICE_DIFFERENCE' | transloco }}" />
      @if (!bulkUpdateParkingPricingForm.controls.priceDifference.valid && bulkUpdateParkingPricingForm.controls.priceDifference.touched) {
        <mat-error
          >
          {{ 'PARKING_PRICING.FORM.PRICE_DIFFERENCE_IS_REQUIRED' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <!-- Day Range Control -->
    <div class="day-range-container">
      <h3 class="mb-2">{{ 'PARKING_PRICING.FORM.DAY_RANGE' | transloco }}</h3>

      <div class="day-range-inputs">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'PARKING_PRICING.FORM.FROM_DAY' | transloco }}</mat-label>
          <input matInput type="number" formControlName="fromDay" [min]="minDay" [max]="maxDay"
            (input)="onFromDayChange()" placeholder="{{ 'PARKING_PRICING.FORM.ENTER_FROM_DAY' | transloco }}" />
          @if (bulkUpdateParkingPricingForm.controls.fromDay.hasError('required')) {
            <mat-error>
              {{ 'PARKING_PRICING.FORM.FROM_DAY_IS_REQUIRED' | transloco }}
            </mat-error>
          }
          @if (bulkUpdateParkingPricingForm.controls.fromDay.hasError('min')) {
            <mat-error>
              {{ 'PARKING_PRICING.FORM.MIN_DAY_VALUE' | transloco }} {{ minDay }}
            </mat-error>
          }
          @if (bulkUpdateParkingPricingForm.controls.fromDay.hasError('max')) {
            <mat-error>
              {{ 'PARKING_PRICING.FORM.MAX_DAY_VALUE' | transloco }} {{ maxDay }}
            </mat-error>
          }
          @if (bulkUpdateParkingPricingForm.controls.fromDay.hasError('rangeInvalid')) {
            <mat-error>
              {{ 'PARKING_PRICING.FORM.FROM_DAY_MUST_BE_LESS_THAN_TILL_DAY' | transloco }}
            </mat-error>
          }
        </mat-form-field>

        <div class="range-separator">-</div>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'PARKING_PRICING.FORM.TILL_DAY' | transloco }}</mat-label>
          <input matInput type="number" formControlName="tillDay" [min]="minDay" [max]="maxDay"
            (input)="onTillDayChange()" placeholder="{{ 'PARKING_PRICING.FORM.ENTER_TILL_DAY' | transloco }}" />
          @if (bulkUpdateParkingPricingForm.controls.tillDay.hasError('required')) {
            <mat-error>
              {{ 'PARKING_PRICING.FORM.TILL_DAY_IS_REQUIRED' | transloco }}
            </mat-error>
          }
          @if (bulkUpdateParkingPricingForm.controls.tillDay.hasError('min')) {
            <mat-error>
              {{ 'PARKING_PRICING.FORM.MIN_DAY_VALUE' | transloco }} {{ minDay }}
            </mat-error>
          }
          @if (bulkUpdateParkingPricingForm.controls.tillDay.hasError('max')) {
            <mat-error>
              {{ 'PARKING_PRICING.FORM.MAX_DAY_VALUE' | transloco }} {{ maxDay }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      @if (minDay && maxDay) {
        <div class="day-range-info mb-3">
          <small class="text-muted">
            {{ 'PARKING_PRICING.FORM.AVAILABLE_DAYS_RANGE' | transloco }}: {{ minDay }} - {{ maxDay }}
          </small>
        </div>
      }
    </div>

  </form>

</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <button mat-raised-button color="primary" (click)="submitForm()" [disabled]="bulkUpdateParkingPricingForm.invalid || isLoading">
    <span>
      {{ 'PARKING_PRICING.FORM.UPDATE' | transloco }}
    </span>
  </button>
  <button mat-button mat-dialog-close [disabled]="isLoading">
    {{ 'PRICING.FORM.CANCEL' | transloco }}
  </button>
</mat-dialog-actions>
